import project from './project'
import diagnostic from './diagnostic'
import hypothesis from './hypothesis'
import auth from './auth'
import user from './user'
import dictionary from './dictionary'
import task from './task'
import support from './support'
import dashboard from './dashboard'
import data from './data'
import file from './file'
import llm from './llm'
import discoveries from './discoveries'
import insights from './insights'
import notifications from './notifications'
import creative from './creative'
import errors from './errors'
import referral from './referral'
import metrics from './metrics'
import units from './units'
import invoice from './invoice'
import research from './research'
import network from './network'
import partnerContent from './partner-content'
import uploadFileType from './upload-file-type'
import uploadedFile from './uploaded-file'

export const API_END_POINTS = {
  project,
  diagnostic,
  hypothesis,
  auth,
  user,
  dictionary,
  task,
  support,
  dashboard,
  data,
  file,
  llm,
  discoveries,
  insights,
  notifications,
  creative,
  errors,
  referral,
  metrics,
  units,
  invoice,
  research,
  network,
  partnerContent,
  uploadFileType,
  uploadedFile,
}
